import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=305395&ext=.webp',
    alt: 'Zdjęcie wyróżniające w hero - strona oferty',
};

export default function CheckoutPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Szybkie płatności w sklepie internetowym IdoSell"
                subTitle="Ułatw i przyspiesz składanie zamówień w sklepie internetowym i zwiększ swoją konwersję, dzięki usłudze Checkout 2.0 od IdoSell"
                image={image}
                buttons={[
                    {
                        title: 'Wypróbuj demo sklepu',
                        href: 'https://www.idosell.com/pl/demo/try-idosell-demo-for-free/',
                        variant: 'default',
                    },
                    {
                        title: 'Zamów sklep',
                        href: 'https://www.idosell.com/pl/abonamenty/',
                        variant: 'outline-reverted',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <ChakraTilesSection
                        title={'Poznaj Checkout 2.0 w IdoSell'}
                        subtitle="W ramach usługi Checkout 2.0 oferujemy Ci 4 różne możliwości finalizacji zakupów dla Twoich klientów. "
                        adding="Każde dopasowane do potrzeb Twoich klientów. Ponadto korzystając z usług Checkout 2.0 i IdoPay nie pobieramy dodatkowych prowizji w ramach IdoPay."
                        titleLeft={true}
                        tiles={[
                            {
                                title: 'Express Checkout',
                                content:
                                    'czyli ekspresowa finalizacja zakupów za pomoca jednego kliknięcia.',
                                logoImage: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=305392&ext=.png',
                                    alt: 'Logo IdoSell',
                                },
                                // link: {
                                //     label: 'Przejdź',
                                //     href: 'https://www.idosell.com/pl/integracje/',
                                //     target: '_blank',
                                // },
                            },
                            {
                                title: 'One Step Checkout',
                                content:
                                    'czyli jednokrokowy proces składania zamówienia. Twoi klienci nie muszą przeklikiwać się pomiędzy kolejnymi stronami.',
                                logoImage: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=305392&ext=.png',
                                    alt: 'Logo IdoSell',
                                },
                                // link: {
                                //     label: 'Przejdź',
                                //     href: 'https://www.idosell.com/pl/system-zarzadzania-magazynem/',
                                //     target: '_blank',
                                // },
                            },
                            {
                                title: '1-Click (Apple Pay & Google Pay)',
                                content: 'szybkie i bezpieczne zakupy za pomocą jednego kliknięcia',
                                logoImage: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=305393&ext=.png',
                                    alt: 'Logo IdoSell',
                                },
                                // link: {
                                //     label: 'Przejdź',
                                //     href: 'https://www.idosell.com/pl/sprzedaz-miedzynarodowa/',
                                //     target: '_blank',
                                // },
                            },
                            {
                                title: 'InPost Pay',
                                content: 'jedna z najpopularniejszych metod finalizacji zakupów.',
                                logoImage: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=305394&ext=.png',
                                    alt: 'Logo IdoSell',
                                },
                                // link: {
                                //     label: 'Przejdź',
                                //     href: 'https://www.idosell.com/pl/order/',
                                //     target: '_blank',
                                // },
                            },
                        ]}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                    color={'white'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundImage:
                                'https://www.idosell.com/panel/file-gate.php?id=305452&ext=.png',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        },
                    }}
                >
                    <BenefitsSectionWithImage
                        title="Sprawdź, co zyskasz dzięki usłudze Checkout 2.0 "
                        subtitle="Poznaj rozwiązania dostępne w usłudze Checkout 2.0. 
Naszą ideą jest maksymalizowanie sprzedaży naszych klientów, dlatego chcemy udostępniać najlepsze rozwiązania rynkowe."
                        layoutSchema="3x1"
                        benefits={[
                            {
                                benefitsTitle: 'Brak opłat za IdoPay przy włączeniu Checkout 2.0.',
                                benefitsText:
                                    'Jeżeli wybierzesz Checkout 2.0 prowizja za płatności IdoPay zostanie obniżona do 0%.',
                            },
                            {
                                benefitsTitle: 'Szybszą finalizację zamówień w twoim sklepie',
                                benefitsText:
                                    'czyli nowoczesne rozwiązania checkoutowe przyspieszają finalizację zamówień, co wpływa na wzrost konwersji.',
                            },
                            {
                                benefitsTitle:
                                    'Dostęp do szybkich płatności Apple Pay, Google Pay, Paypal, InPost Pay.',
                                benefitsText:
                                    'Możesz korzystać z szybkich metod płatności, które zwiększą Twoją konwersję.',
                            },
                            {
                                benefitsTitle: 'Jeszcze wyższą konwersję',
                                benefitsText: 'dzięki przyspieszonym metodom finalizacji zamówień',
                            },
                            {
                                benefitsTitle: 'Gwarancję stałego rozwoju i optymalizacji usługi',
                                benefitsText:
                                    'W IdoSell dbamy o nieustanny rozwój naszych rozwiązań. Dlatego też, dajemy Ci pewność, że usługa będzie stale rozbudowywana.',
                            },
                            {
                                benefitsTitle: 'Wiele operatorów płatniczych',
                                benefitsText:
                                    'W planach abonamentowych ograniczonych domyślnie wyłącznie do płatności IdoPay',
                            },
                        ]}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <ExtendedTabsSection
                        title="Poznaj najważniejsze funkcjonalności IdoSell"
                        subtitle="Naszą ideą jest maksymalizowanie sprzedaży naszych klientów, dlatego chcemy udostępniać najlepsze rozwiązania rynkowe"
                        tabsContent={[
                            {
                                tabTitle: 'Dedykowany, customowy wygląd sklepu',
                                tabName: 'Express Checkout',
                                content: (
                                    <Box>
                                        <Box
                                            background={'rgba(238, 238, 238, 1)'}
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305605&ext=.png"
                                                    alt=""
                                                    mb={'15px'}
                                                ></Image>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Express Checkout - szybkie zakupy online jednym
                                                    kliknięciem
                                                </Text>
                                                <Text fontSize={'18px'} lineHeight={'27px'}>
                                                    Wszystko, co muszą zrobić twoi klienci, to
                                                    wybrać produkt lub usługę, którą chcą kupić.
                                                    Zostanie ona bezpiecznie opłacona za pomocą
                                                    jednego kliknięcia.
                                                </Text>
                                            </Box>
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305602&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <picture>
                                                    <source
                                                        media="(min-width: 430px)"
                                                        srcSet="https://www.iai-system.com/panel/file-gate.php?id=274023.mp4"
                                                        type="video/mp4"
                                                    />
                                                    <source srcSet="https://www.iai-system.com/panel/file-gate.php?id=274023.mp4" />
                                                    <video
                                                        width="100%"
                                                        controls
                                                        autoPlay
                                                        muted
                                                        loop
                                                    >
                                                        <source
                                                            src="https://www.iai-system.com/panel/file-gate.php?id=274023.mp4"
                                                            type="video/mp4"
                                                        />
                                                    </video>
                                                </picture>
                                            </Box>
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Szybkie logowanie – ekspresowa płatność
                                                </Text>
                                                <Text
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                    mb={'15px'}
                                                >
                                                    Szybkie logowanie dzięki biometrii zapewnia
                                                    klientom wygodę i bezpieczeństwo, umożliwiając
                                                    logowanie się jednym dotknięciem lub
                                                    spojrzeniem. Co więcej, opcja logowania za
                                                    pomocą PINu obok biometrii zapewnia
                                                    elastyczność, umożliwiając klientom korzystanie
                                                    z tych funkcji również na urządzeniach, które
                                                    nie posiadają wbudowanych funkcji
                                                    biometrycznych.
                                                </Text>
                                                <Text fontSize={'18px'} lineHeight={'27px'}>
                                                    Twój klient może także skorzystać z szybkiego
                                                    logowania za pomocą otrzymanego na numer
                                                    telefonu kodu SMS.
                                                </Text>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column-reverse', lg: 'row' }}
                                        >
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Synergia sklepów IdoSell
                                                </Text>
                                                <Text
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                    mb={'15px'}
                                                >
                                                    Jeśli klient robił już zakupy w sklepie
                                                    zbudowanym na IdoSell, to za pomocą jednego
                                                    kliknięcia, będzie mógł dokonać szybkich i
                                                    bezpiecznych zakupów bez konieczności ponownego
                                                    podawania swoich danych we wszystkich sklepach
                                                    internetowych IdoSell, które korzystają z
                                                    Express Checkout.
                                                </Text>
                                            </Box>
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305604&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                        </Box>
                                    </Box>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305543&ext=.webp',
                            },
                            {
                                tabTitle: 'Narzędzia z gwarancją skuteczności',
                                tabName: 'One Step Checkout',
                                content: (
                                    <Box>
                                        <Box
                                            background={'rgba(238, 238, 238, 1)'}
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305605&ext=.png"
                                                    alt=""
                                                    mb={'15px'}
                                                    display={'flex'}
                                                    justifyContent={'center'}
                                                ></Image>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    One Step Checkout
                                                </Text>
                                                <Text fontSize={'18px'} lineHeight={'27px'}>
                                                    Jednokrokowy proces składania zamówienia.
                                                    Optymalizuje składanie zamówienia do jednej
                                                    strony, zamiast standatrdowych czterech kroków
                                                </Text>
                                            </Box>
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305613&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                        >
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                display={'flex'}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305614&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                padding={'30ox'}
                                            >
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Szybkie i wygodne zakupy dla Twoich klientów
                                                </Text>
                                                <Text fontSize={'18px'} lineHeight={'27px'}>
                                                    Nawet 2 razy szybsze zakupy (w porównaniu do
                                                    standardowego checkoutu), dzięki temu, że
                                                    wszystkie niezbędne elementy do uzupełnienia
                                                    znajdują się na jednej stronie. 
                                                </Text>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column-reverse', lg: 'row' }}
                                        >
                                            <Box width={'50%'}>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    A także
                                                </Text>
                                                <List
                                                    spacing={'15px'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                >
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Mniej porzuconych koszyków
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Mniejsze ryzyko porzucenia koszyka,
                                                                dzięki ujęciu wszystkich etapów
                                                                procesu zakupowego na jednej
                                                                stronie.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Krótka ścieżka zakupowa
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Użytkownik widzi od razu całą
                                                                ścieżkę, którą musi przejść, żeby
                                                                sfinalizować zakup.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Większa satysfakcję z zakupów
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Dzięki szybkiej finalizacji
                                                                transakcji klient ma większą
                                                                satysfakcję z zakupów w twoim
                                                                sklepie internetowym.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                            <Box
                                                width={'50%'}
                                                display={'flex'}
                                                justifyContent={'center'}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305615&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                        </Box>
                                    </Box>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305544&ext=.jpeg',
                            },
                            {
                                tabTitle: 'Bezpieczeństwo, wsparcie i askepty prawne',
                                tabName: '1-Click (Apple Pay & Google Pay)',
                                content: (
                                    <Box>
                                        <Box
                                            background={'rgba(238, 238, 238, 1)'}
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305618&ext=.png"
                                                    alt=""
                                                    mb={'15px'}
                                                    display={'flex'}
                                                    justifyContent={'center'}
                                                ></Image>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    1-Click
                                                    <Text fontSize={'18px'} lineHeight={'27px'}>
                                                        (Apple Pay & Google Pay)
                                                    </Text>
                                                </Text>
                                                <Text fontSize={'18px'} lineHeight={'27px'}>
                                                    Optymalizuje składanie zamówienia do jednej
                                                    strony, zamiast standatrdowych czterech kroków
                                                </Text>
                                            </Box>
                                            <Box width={{ base: '100%', lg: '50%' }}>
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305616&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                        </Box>
                                        <Box
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                display={'flex'}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305617&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                padding={'30ox'}
                                            >
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Płatności 1-Click to
                                                </Text>
                                                <List
                                                    spacing={'15px'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                >
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Mniej porzuconych koszyków
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Mniejsze ryzyko porzucenia koszyka,
                                                                dzięki ujęciu wszystkich etapów
                                                                procesu zakupowego na jednej
                                                                stronie.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                    <ListItem display={'flex'}>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                            mt={'5px'}
                                                        />
                                                        <Box>
                                                            <Text
                                                                fontSize={'21px'}
                                                                lineHeight={'1.5'}
                                                                fontWeight={'600'}
                                                                mb="5px"
                                                            >
                                                                Większa satysfakcję z zakupów
                                                            </Text>
                                                            <Text
                                                                fontSize={'16px'}
                                                                lineHeight={'1.5'}
                                                                mb="5px"
                                                            >
                                                                Dzięki szybkiej finalizacji
                                                                transakcji klient ma większą
                                                                satysfakcję z zakupów w twoim
                                                                sklepie internetowym.
                                                            </Text>
                                                        </Box>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                    </Box>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305545&ext=.webp',
                            },
                            {
                                tabTitle: 'Zarządzanie klientami',
                                tabName: 'InPost Pay',
                                content: (
                                    <Box>
                                        <Box
                                            backgroundImage={{
                                                base: 'rgba(238, 238, 238, 1)',
                                                lg: "url('https://www.idosell.com/panel/file-gate.php?id=305619&ext=.png')",
                                            }}
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            objectFit={'cover'}
                                            backgroundRepeat={'round'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box
                                                width={{
                                                    base: '100%',
                                                    md: 'calc(100%/12*5)',
                                                }}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305621&ext=.png"
                                                    alt=""
                                                    mb={'15px'}
                                                    display={'flex'}
                                                    justifyContent={'center'}
                                                ></Image>
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    InPost Pay
                                                </Text>
                                                <Text
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                    mb={'15px'}
                                                >
                                                    Skorzystaj z wyjątkowego rozwiązania
                                                    technologicznego, łączącego zakupy, płatność i
                                                    dostawę w jednym przycisku.
                                                </Text>
                                                <Text fontSize={'18px'} lineHeight={'27px'}>
                                                    Dzięki InPost Pay twoi klienci mogą wygodnie
                                                    finalizować zakupy - bez konieczności
                                                    wypełniania formularzy i podawania swoich
                                                    danych. Aplikacja InPost Mobile pamięta dane
                                                    kupującego, ulubioną formę dostawy i płatności.
                                                </Text>
                                            </Box>
                                            <Box width={{ base: '0%', lg: '50%' }}></Box>
                                        </Box>
                                        <Box
                                            padding={'50px'}
                                            display={'flex'}
                                            gap={'30px'}
                                            alignItems={'center'}
                                            flexDir={{ base: 'column', lg: 'row' }}
                                        >
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                display={'flex'}
                                            >
                                                <Image
                                                    src="https://www.idosell.com/panel/file-gate.php?id=305620&ext=.png"
                                                    alt=""
                                                ></Image>
                                            </Box>
                                            <Box
                                                width={{ base: '100%', lg: '50%' }}
                                                padding={'30ox'}
                                            >
                                                <Text
                                                    fontSize={'34px'}
                                                    lineHeight={'48px'}
                                                    fontWeight={'600'}
                                                    mb={'15px'}
                                                >
                                                    Zyskaj więcej dzięki InPost Pay
                                                </Text>
                                                <List
                                                    spacing={'15px'}
                                                    fontSize={'18px'}
                                                    lineHeight={'27px'}
                                                >
                                                    <ListItem>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                        />
                                                        Wzrost konwersji
                                                    </ListItem>
                                                    <ListItem>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                        />
                                                        Mniej porzuconych koszyków
                                                    </ListItem>
                                                    <ListItem>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                        />
                                                        Większą częstotliwość zamówień
                                                    </ListItem>
                                                    <ListItem>
                                                        <ListIcon
                                                            as={CheckIcon}
                                                            color="green.500"
                                                            mr={'30px'}
                                                        />
                                                        Więcej nowych kupujących
                                                    </ListItem>
                                                </List>
                                                <Box mt={5}>
                                                    <ButtonContainer>
                                                        <StyledButton
                                                            style="default"
                                                            target="_blank"
                                                            href={
                                                                'https://pomoc.idosell.com/platnosci/inpost-pay/inpostpay'
                                                            }
                                                        >
                                                            Włącz InPost Pay
                                                        </StyledButton>
                                                    </ButtonContainer>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305546&ext=.webp',
                            },
                        ]}
                    />
                </Box>
                <WhyService
                    title="Dlaczego szybkie rozwiązania checkout są tak ważne w twoim sklepie?"
                    list={[
                        {
                            featuredMainNumber: '62',
                            featuredAddingNumber: ' %',
                            featuredText:
                                'klientów rezygnuje z zakupu po  2 minutach, gdzie ukończenie tego procesu zajmuje średnio ponad 3 minuty',
                            addingText: '* Według danych Stripe',
                        },
                        {
                            featuredMainNumber: '80',
                            featuredAddingNumber: ' %',
                            featuredText:
                                'stron ma zbyt skomplikowane wymagania dotyczące tworzenia haseł',
                            addingText: '* Według danych Baymard Institute',
                        },
                    ]}
                />
                <CTASection
                    title="Skontaktuj się z ekspertem IdoSell i włącz Checkout 2.0 w swoim sklepie"
                    subtitle="Express Checkout dostępny jest dla wszystkich sklepów internetowych z włączonym systemem płatności IdoPay i aktualnym szablonem sklepu. Zamów darmową konsultację z naszym specjalistą, który przeprowadzi cię przez cały proces włączenia usługi."
                    buttons={[
                        {
                            title: 'Zamów konsultację z ekspertem',
                            href: 'https://eu1.hubs.ly/H08swyQ0',
                            variant: 'default',
                        },
                    ]}
                />
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                    position={'relative'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: 'rgba(238, 238, 238, 1)', // Replace with your theme color reference
                        },
                    }}
                >
                    <FAQ
                        title="Najczęściej zadawane pytania"
                        list={[
                            {
                                question: 'Czy Checkout 2.0 to tak naprawdę kilka usług w jednej?',
                                anwser: (
                                    <Text>
                                        Tak, Checkout 2.0 daje Ci wiele możliwości zastosowania
                                        nowoczesnych rozwiązań checkotowych – Express Checkout, One
                                        Page Checkout Process, Apple Pay, Google Pay i Inpost Pay.
                                        Możesz skorzystać z wybranych usług lub włączyć je
                                        wszystkie, korzystając z jednej stawki.
                                    </Text>
                                ),
                            },
                            {
                                question: 'Jakie są najważniejsze korzyści usługi Checkout 2.0? ',
                                anwser: (
                                    <UnorderedList>
                                        <ListItem>
                                            Szybsza finalizacja zamówień w twoim sklepie,
                                        </ListItem>
                                        <ListItem>jeszcze wyższa konwersja,</ListItem>
                                        <ListItem>
                                            brak opłat za transakcje przy wyborze IdoPay,
                                        </ListItem>
                                        <ListItem>
                                            wiele rozwiązań checkoutowych w ramach jednej usługi.
                                        </ListItem>
                                    </UnorderedList>
                                ),
                            },
                            {
                                question:
                                    'Czy w usłudze Chekout 2.0 płacę za każdą usługę osobno (Express Chekout, One Step Checkout, Apple Pay & Google Pay, InPost Pay)?',
                                anwser: (
                                    <Text>
                                        Nie, jest jedna stawka za możliwość korzystania ze
                                        wszystkich lub wybranych usług w ramach Checkout 2.0.
                                        Dodatkowo, przy włączonej usłudze Checkout 2.0, płatności
                                        IdoPay są całkowicie za darmo!
                                    </Text>
                                ),
                            },
                            {
                                question:
                                    'Co gdy chcę skorzystać z usługi Checkout 2.0, a nie mogę skorzystać z IdoPay i nie chcę płacić podwójnie?',
                                anwser: (
                                    <Text>
                                        <Link href="#" isExternal>
                                            Skontaktuj się z nami
                                        </Link>
                                        , a wspólnie wybierzemy najbardziej optymalne rozwiązanie
                                        dla twojego sklepu internetowego.
                                    </Text>
                                ),
                            },
                            {
                                question: 'Co gdy nie chcę korzystać z Checkout 2.0?',
                                anwser: (
                                    <UnorderedList>
                                        <ListItem>
                                            Nie masz dostępu do systemowych rozwiązań - Express
                                            Checkout i One Page Checkout Process.
                                        </ListItem>
                                        <ListItem>
                                            Nie masz możliwości skorzystania z mechanizmów silnika,
                                            wspierających systemowe rozwiązanie One Page Checkout
                                            Process.
                                        </ListItem>
                                        <ListItem>
                                            W koszyku masz dostępne jedynie w pełni funkcjonalne
                                            rozwiązanie 4-krokowego procesu składania zamówienia
                                            (Standard Checkout Process).
                                        </ListItem>
                                    </UnorderedList>
                                ),
                            },
                            {
                                question: 'Jakie zamówienia podlegają opłacie za Checkout 2.0?',
                                anwser: (
                                    <Flex direction={'column'} gap={2}>
                                        <Text>
                                            Opłatą za skorzystanie z usługi jest prowizja od każdego
                                            zamówienia kwalifikowanego, niezależnie od metody
                                            płatności:
                                        </Text>
                                        <UnorderedList>
                                            <ListItem>
                                                karty płatnicze, PayByLink, Blik, płatności
                                                odroczone, Stripe, Klarna, PayPal
                                            </ListItem>
                                            <ListItem>
                                                inni operatorzy (płatności zrealizowane dowolnym z
                                                operatorów płatności)
                                            </ListItem>
                                            <ListItem>
                                                pobrania, przelew bankowy, bony, karta podarunkowa,
                                                raty, leasing, kredyt kupiecki
                                            </ListItem>
                                        </UnorderedList>
                                        <Text>
                                            W ramach Checkout 2.0, zamówienie kwalifikowane to każde
                                            zamówienie sklepowe, składane w interfejsie strony
                                            sklepu. Nie podchodzą pod to zamówienia generowane
                                            ręcznie w panelu czy API.
                                        </Text>
                                        <Text>
                                            Rozliczana jest wartość zamówienia, a nie suma wpłat.
                                        </Text>
                                        <Text>
                                            Do wyboru stawki jest brana pod uwagę pierwsza
                                            zaksięgowana wpłata, a w przypadku jej braku, pierwsza
                                            nieanulowana deklaracja wpłaty."
                                        </Text>
                                    </Flex>
                                ),
                            },
                            {
                                question: 'Czy mogę uzyskać wsparcie podczas włączenia usługi?',
                                anwser: (
                                    <Text>
                                        Podczas włączania usługi Checkout 2.0 możesz uzyskać pomoc
                                        naszych ekspertów, korzystając z Centrum Supportu.
                                    </Text>
                                ),
                            },
                            {
                                question: 'Gdzie znajdę cennik i regulamin usługi?',
                                anwser: (
                                    <>
                                        <Text>
                                            Cennik usługi: {''}
                                            <Link
                                                fontWeight="700"
                                                href="https://www.idosell.com/pl/otworz-swoj-wlasny-sklep-internetowy/"
                                            >
                                                https://www.idosell.com/pl/otworz-swoj-wlasny-sklep-internetowy/
                                            </Link>
                                        </Text>
                                        <Text>
                                            Regulamin usługi: {''}
                                            <Link
                                                fontWeight="700"
                                                href="https://www.idosell.com/pl/regulamin-idosell/"
                                            >
                                                https://www.idosell.com/pl/regulamin-idosell/
                                            </Link>
                                        </Text>
                                    </>
                                ),
                            },
                        ]}
                    />
                </Box>
                {/* <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                    position={'relative'}
                >
                    <ConnectedArticles
                        title="Chcesz dowiedzieć się więcej o Checkout 2.0?"
                        subtitle="Zapoznaj się z naszymi materiałami edukacyjnymi i przekonaj się jak lorem ipsum dolor sit amet."
                        articles={[
                            {
                                title: (
                                    <Text fontWeight={'700'} fontSize={'14px'} lineHeight={'18px'}>
                                        Jak sprzedawać szybciej, wygodniej i zwiększyć konwersję?{' '}
                                        <Text
                                            as={'span'}
                                            display={'block'}
                                            color={'rgba(26, 172, 122, 1)'}
                                        >
                                            Usługa Express Checkout w IdoSell
                                        </Text>
                                    </Text>
                                ),
                                imgUrl: '',
                                link: {
                                    href: 'https://www.idosell.com/pl/blog/jak-sprzedawac-szybciej-wygodniej-i-zwiekszyc-konwersje-usluga-express-checkout-w-idosell-1235327944',
                                    labelText: 'Przeczytaj artykuł',
                                },
                            },
                            {
                                title: (
                                    <Text fontWeight={'700'} fontSize={'14px'} lineHeight={'18px'}>
                                        Jak skutecznie sprzedawać{' '}
                                        <Text
                                            as={'span'}
                                            display={'block'}
                                            color={'rgba(26, 172, 122, 1)'}
                                        >
                                            w modelu crossborder ?
                                        </Text>
                                    </Text>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305781&ext=.png',
                                link: {
                                    href: '',
                                    labelText: 'Przeczytaj artykuł',
                                },
                            },
                            {
                                title: (
                                    <Text fontWeight={'700'} fontSize={'14px'} lineHeight={'18px'}>
                                        <Text
                                            as={'span'}
                                            display={'block'}
                                            color={'rgba(26, 172, 122, 1)'}
                                        >
                                            Wyzwania crossborder.
                                        </Text>
                                        Jak skutecznie przygotować sklep do sprzedaży
                                        międzynarodowej?
                                    </Text>
                                ),
                                imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=305782&ext=.png',
                                link: {
                                    href: '',
                                    labelText: 'Przeczytaj artykuł',
                                },
                            },
                        ]}
                    />
                </Box> */}
            </div>
        </ThemeProvider>
    );
}
